// @flow

import { createRemoteData } from "@quantum/remote-data";

export const [useArquivosMedidas, ArquivosMedidas] = createRemoteData(
  "arquivosMedidas"
);

export const [useTemplateMedidas, TemplateMedidas] = createRemoteData(
  "templatesMedidas"
);

export const [useDatasSelecaoJanela, DatasSelecaoJanela] = createRemoteData(
  "datasSelecaoJanela"
);

export const [
  useGruposCompartilhamento,
  GruposCompartilhamento,
] = createRemoteData("gruposCompartilhamento");

export const [
  useValidacaoExpressaoMedidaComposta,
  ValidacaoExpressaoMedidaComposta,
] = createRemoteData("validacaoExpressaoMedidaComposta");

export const [
  useValidacaoExpressaoSintaxe,
  ValidacaoExpressaoSintaxe,
] = createRemoteData("validacaoExpressaoSintaxe");

export const [useBuscaAtivos, BuscaAtivos] = createRemoteData("buscaAtivos");

export const [
  useBuscaAtivosSelecionaveis,
  BuscaAtivosSelecionaveis,
] = createRemoteData("buscaAtivosSelecionaveis");

export const [useBuscaAtivosColecao, BuscaAtivosColecao] = createRemoteData(
  "buscaAtivosColecao"
);

export const [
  useBuscaInformacoesAdicionaisAtivos,
  BuscaInformacoesAdicionaisAtivos,
] = createRemoteData("buscaInformacoesAdicionaisAtivos");

export const [useClonaReport, ClonaReport] = createRemoteData("clonaReport");
